import React, { useState } from "react";
import { FaEdit, FaTrash } from "react-icons/fa";
import { useFormik } from "formik";
import { toast } from "react-toastify";
import BaseModal from "../../popups/model";
import { Input } from "../../form";
import { updateRegionalEvent, deleteRegionalEvent } from "../../../service";
import AdminPanelButton from "../../form/button/adminPanelButton";

export default function OrgRegionalEvent({
  event,
  prefilledData,
  getAdminRegionalEvents,
  updatedOrderKey
}) {
  const [editOpen, setEditOpen] = useState(false);
  const [loading, setLoading] = useState(false);

  const submitHandler = async () => {
    setLoading(true);

    try {
      const res = await updateRegionalEvent(prefilledData._id, event._id, {
        ...formik.values
      });
      getAdminRegionalEvents();

      toast.success(res.data);
    } catch (err) {
      console.log(err);
    } finally {
      setLoading(false);
      formik.resetForm();
      setEditOpen(!editOpen);
    }
  };

  const deleteHandler = async () => {
    if (window.confirm("Are you sure you want to delete this event?")) {
      try {
        const res = await deleteRegionalEvent(prefilledData._id, event._id);
        getAdminRegionalEvents();

        toast.success(res.data);
      } catch (err) {
        console.log(err);
      }
    }
  };

  const formik = useFormik({
    initialValues: {
      name_de: event?.name_de || "",
      name_en: event?.name_en || "",
      name_fr: event?.name_fr || "",
      name_it: event?.name_it || ""
    },
    onSubmit: submitHandler
  });

  return (
    <>
      <div className="flex items-center justify-between p-4 bg-white rounded-lg shadow-sm border">
        <div className="flex-1">
          <h3 className="text-lg font-medium text-gray-900">
            {event?.name_en ||
              event?.name_de ||
              event?.name_fr ||
              event?.name_it ||
              "Untitled Event"}
          </h3>
          <div className="mt-1 text-sm text-gray-500">
            <span className="mr-4">DE: {event?.name_de || "N/A"}</span>
            <span className="mr-4">EN: {event?.name_en || "N/A"}</span>
            <span className="mr-4">FR: {event?.name_fr || "N/A"}</span>
            <span>IT: {event?.name_it || "N/A"}</span>
          </div>
        </div>
        <div className="flex items-center space-x-2">
          <button
            onClick={() => setEditOpen(!editOpen)}
            className="p-2 text-blue-600 hover:text-blue-800 transition-colors">
            <FaEdit />
          </button>
          <button
            onClick={deleteHandler}
            className="p-2 text-red-600 hover:text-red-800 transition-colors">
            <FaTrash />
          </button>
        </div>
      </div>

      <BaseModal open={editOpen} setOpen={setEditOpen} title={"Edit Regional Event"}>
        <form onSubmit={formik.handleSubmit}>
          <div className="grid grid-cols-2 gap-2">
            <Input
              label="DE"
              name="name_de"
              formik={formik}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              value={formik?.values["name_de"]}
              error={formik?.errors["name_de"]}
              touched={formik?.touched["name_de"]}
            />
            <Input
              label="EN"
              name="name_en"
              formik={formik}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              value={formik?.values["name_en"]}
              error={formik?.errors["name_en"]}
              touched={formik?.touched["name_en"]}
            />
            <Input
              label="FR"
              name="name_fr"
              formik={formik}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              value={formik?.values["name_fr"]}
              error={formik?.errors["name_fr"]}
              touched={formik?.touched["name_fr"]}
            />
            <Input
              label="IT"
              name="name_it"
              formik={formik}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              value={formik?.values["name_it"]}
              error={formik?.errors["name_it"]}
              touched={formik?.touched["name_it"]}
            />
          </div>

          <div className="mt-5 sm:mt-4 grid grid-cols-2 gap-4">
            <AdminPanelButton
              type="submit"
              isSave={true}
              loading={loading}
              bgColor="#FC9E5A"
              textColor="#FFFFFF"
              color="white"
              onClick={() => {}}>
              update
            </AdminPanelButton>
          </div>
        </form>
      </BaseModal>
    </>
  );
}
